module.exports = __webpack_public_path__ + "img/character-dog-sad.7fdd4447.svg";